import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import * as utils from '@ivy/fts/utils';
let OrderPay = class OrderPay extends Vue {
    constructor() {
        super(...arguments);
        this.aliPayForm = '';
        this.paying = true;
        this.order_id = '';
        this.redirect = '';
    }
    get isWeixinWeb() {
        return utils.isWeixin();
    }
    goWx() {
        window.location.href = 'weixin://';
    }
};
OrderPay = tslib_1.__decorate([
    Component({})
], OrderPay);
export default OrderPay;
